<template>
  <section class="wrap">
    <div class="head">
      <div class="wire"></div>
      <span class="title">我的班级</span>
      <el-button  class="mr28 fr mt32 btn_custom_primary" @click="joinClassVisible = true; form.code = ''">加入班级</el-button>
    </div>

    <div class="content">
      <el-tabs class="class-tabs-c mt20" v-model="activeName">
        <el-tab-pane label="我的班级" name="first"></el-tab-pane>
      </el-tabs>
      <div class="search_course">
        <el-input  @keyup.enter.native="changeRouteQuery({page:1})" clearable class="input-with-select search_input"
                   placeholder="请输入课程、班级名称/教师姓名" v-model="searchMassage" @clear="changeRouteQuery({page:1})">
          <el-button @click="changeRouteQuery({page:1})" slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <div class="content_card">
        <el-card class="card"  v-for="(item, index) in gettersStudentExamClassList.list" :key="index" :body-style="{ padding: '0px' }">
          <access-router-link :to="{name:'class_public_teaching',
          query:{tab_index:0},params:{class_id:item.id,course_id:item.school_course_id}}">
            <img v-lazy="item.picture" class="image" :key="item.picture">
            <div class="p14">
              <div>
                <div class="card_book_name long">{{item.course_name}}</div>
                <span class="fr">
                  <el-dropdown  @command="handleCommand">
                <span class="el-dropdown-link finger">
                    <i @click.prevent class="el-icon-more-outline el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{
                      type:'jump',
                      data:{
                        url: 'student_examination_list',
                        id: item.id,
                        class_name:item.grade_name
                      }
                  }">考试查看</el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown>
                 </span>
              </div>
              <div class="card_creation_time">开课班级：{{item.grade_name}}</div>
              <div class="card_creation_time">任课教师：{{get(item,'teacher.name')}}</div>
            </div>
          </access-router-link>

        </el-card>
      </div>
      <div class="bafflePlate"></div>

    </div>

    <div class="nodata" v-if="gettersStudentExamClassList.list.length<=0">
      <img src="../../../assets/img/087E072F-AF7F-4A14-ACC1-D1A3BCA6F32E.png">
    </div>
    <div class="nodata" v-if="gettersStudentExamClassList.list.length<=0">
      <div class="hidden_font_style">暂时还没有课程....</div>
    </div>
    <div class="pagination" v-if="gettersStudentExamClassList.list.length>=1">
      <el-pagination
        @size-change="changeRouteQuery({
          size:arguments[0],
          page:1
        })"
        @current-change="changeRouteQuery({
          page:arguments[0]
        })"
        background
        :current-page="paramsQuery.page"
        :page-sizes="[8, 16, 24, 32]"
        :page-size="paramsQuery.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="gettersStudentExamClassList.total">
      </el-pagination>
    </div>

    <el-dialog title="加入班级" :visible.sync="joinClassVisible" width="600px">
      <el-form :model="form" label-width="80px">
        <el-form-item label="班级编码">
          <el-input v-model="form.code"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="joinClassVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="!form.code" @click="joinClassClick(form)">确 定</el-button>
      </span>
    </el-dialog>

  </section>
</template>
<script>
  import {
    extend,
    get
  }  from 'lodash'
  import{
    mapGetters,
    mapActions
  } from 'vuex';
  import {
    toNumber
  } from "../../../common/Fn";

  export default {
    data() {
      return {
        joinClassVisible: false,
        form: {
          code: '',
        }
      };
    },
    filters:{
      filterTime(val){
        let data =  val.split(' ');
        return data[0]
      },
    },
    computed:{
      ...mapGetters({
        'gettersStudentExamClassList':'getStudentExamClassList',//学生考试班级列表
      }),
      searchMassage:{
        get(){
          return this.$route.query.keywords || ''
        },
        set(val){
          let route = this.$route;
          this.$router.replace({
            name:route.name,
            query:extend({},route.query,{keywords:val})
          });
        }
      },
      paramsQuery(){
        let route = this.$route.query;
        return {
          'page': toNumber(route.page,1),
          'size': toNumber(route.size,16),
          keywords: this.searchMassage,
          is_join: 1
        }
      },
      tabName(){
        return ['first','second','third'];
      },
      activeName:{
        get(){
          return this.tabName[this.$route.query.tab_id] ? this.tabName[this.$route.query.tab_id]: 'first'
        },
        set(val){
          this.changeRouteQuery({
            tab_id:this.tabName.indexOf(val),
            page:1,
          });
        }
      }

    },

    methods: {
      ...mapActions({
        'getStudentExamGradeListData':'actionStudentExamGradeListModel',//学生考试班级列表
        'studentExamGradeAdd':'actionStudentExamGradeAdd',//学生加入班级
      }),
      get,
      extend,
      //下拉菜单的切换
      handleCommand(item){
        switch (item.type){
          case 'jump':
            if (!item.isPublish){
              this.$router.push({
                name:item.data.url,
                query:extend({},{id:+item.data.id},{class_name:item.data.class_name})
              });
            }
            break;
        }
      },
      //分页切换
      changeRouteQuery(val){
        let route = this.$route;
        this.$router.push({
          name:route.name,
          query:extend({},route.query,val),
          params:route.params,
        });
        this.$nextTick(()=>{
          this.getList();
        })
      },
      joinClassClick(item) {
        this.studentExamGradeAdd({school_grade_id: item.code}).then(() => {
          this.$message.success('操作成功');
          this.joinClassVisible = false;
          this.getList();
        })
      },
      getList(){
        let query = this.paramsQuery;
        this.getStudentExamGradeListData(query);
      }
    },
    created(){
      this.getList();
    }
  }
</script>

<style lang="scss" scoped>
  .head-btn{
    float: right;
    margin-right: 7px;
    margin-top: 32px;
  }
  >>> .class-tabs-container .el-tabs__content {
    overflow: visible;
  }
  .class-tabs-c >>> .el-tabs__active-bar{
    background-color: $--system-color-primary;
  }
  .class-tabs-c >>> .el-tabs__item.is-active,.class-tabs-c >>> .el-tabs__item:hover{
    color: $--system-color-primary;
  }
  .class-tabs-c >>> .el-tabs__item.is-active,.class-tabs-c >>> .el-tabs__item{
    font-size: 18px;
  }
  >>> .el-pager li.active{
    cursor: default;
    background-color: $--system-color-primary !important;
  }
</style>

<style scoped>
  .pagination{
    margin-top: 20px;
    margin-left: 40px;
  }
  .class-tabs-c{
    padding-right: 28px;
  }
  * :hover{
    text-decoration:none
  }
  .bafflePlate{
    width: 58px;
    height: 20px;
    background-color: white;
    position: absolute;
    right: -40px;
    top: 25px;
    z-index: 3;
  }
  .head{
    height: 116px;
    background-color: #f5f8fa;
    padding-left: 45px;
    padding-right: 45px;
  }
  .head .wire{
    width: 100%;
    height: 1px;
  }
  .head .title{
    font-size: 24px;
    color: #333333;
    display: inline-block;
    margin-top: 32px;
  }

  .search_course{
    background-color: white;
    z-index: 2;
    position: absolute;
    right: -22px;
    top: -5px;
    border-right: 40px solid white;
  }
  .search_input{
    width: 302px;
  }
  .content{
    padding-left: 45px;
    padding-right: 45px;
  }
  .content_card{
    transform: translateY(-10px);
    display: flex;
    flex-flow:row wrap;
  }
  .card{
    position: relative;
    width: 261px;
    margin-right: 13px;
    margin-top: 13px;
  }
  .image {
    width: 100%;
    height: 161px;
    display: block;
  }
  .card_book_name{
    display: inline-block;
    width: 190px;
    font-size: 14px;
    font-weight: 700;
    color: #333333;
  }
  .card_creation_time{
    opacity: 0.5;
    font-size: 12px;
    color: #333333;
    margin-top: 5px;
  }
  .nodata{
    transform: translateY(-50px);
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .hidden_font_style{
    font-size: 32px;
    color: gray;
  }
  .finger{
    cursor: pointer
  }
  .long{
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
</style>
